import { render } from "./LockIcon.vue?vue&type=template&id=1e712bc8&bindings={}"
import script from "./LockIcon.vue?vue&type=script&lang=ts"
export * from "./LockIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script